import {
  ComponentFactoryResolver,
  ComponentRef,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppStateService } from '@shared/services';
import { ModalCloseButtonComponent } from '../close-button/modal-close-button.component';

@Directive({
  selector: '[sharedUiModalClose]',
})
export class ModalCloseDirective implements OnInit, OnDestroy {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly componentFactoryResolver = inject(ComponentFactoryResolver);
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly appStateService = inject(AppStateService);

  withMobileClosing = input<boolean>(true);

  readonly closed = output<void>();

  private componentInstance: ComponentRef<ModalCloseButtonComponent> | null =
    null;
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (
      !(this.appStateService.isMobileResolution() && !this.withMobileClosing())
    ) {
      const componentFactory =
        this.componentFactoryResolver.resolveComponentFactory(
          ModalCloseButtonComponent,
        );

      this.componentInstance =
        this.viewContainerRef.createComponent(componentFactory);

      this.componentInstance.instance.closed
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.closed.emit());

      this.renderer.appendChild(
        this.el.nativeElement,
        this.componentInstance.location.nativeElement,
      );
    }
  }

  ngOnDestroy(): void {
    if (this.componentInstance) {
      this.componentInstance.destroy();
    }
  }
}
